import { useEffect } from 'react'

import { MAX_RETRY, useMovementStatusState } from '../helpers/use-movement-status-state'

import { useFetchMarketMovementStatus } from './use-fetch-market-movement-status'

export function useCheckMarketMovementStatus({ accountId, movementId }: { accountId: string; movementId?: string }) {
  const { status, setStatus, shouldCheckStatus, handleError, handleSuccess, reset } = useMovementStatusState()

  const { isMovementStatusLoading } = useFetchMarketMovementStatus({
    accountId,
    movementId,
    config: {
      enabled: Boolean(accountId && !!movementId && shouldCheckStatus),
      refetchInterval: 1000,
      retry: MAX_RETRY + 1,
      onError: handleError,
      onSuccess: response => handleSuccess(response.status)
    }
  })

  useEffect(() => {
    if (isMovementStatusLoading && status !== 'loading') {
      setStatus('loading')
    }
  }, [isMovementStatusLoading, status, setStatus])

  return { reset, status }
}
